import { withInstall } from '@pit-element-plus/utils'

import LayoutColumn from './src/layout-column.vue'

export const ElLayoutColumn = withInstall(LayoutColumn)
export default ElLayoutColumn

export * from './src/layout-column'
